import { render, staticRenderFns } from "./AddNewProduct.vue?vue&type=template&id=c9baccc8&scoped=true"
import script from "./AddNewProduct.vue?vue&type=script&lang=js"
export * from "./AddNewProduct.vue?vue&type=script&lang=js"
import style0 from "./AddNewProduct.vue?vue&type=style&index=0&id=c9baccc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9baccc8",
  null
  
)

export default component.exports